import { Component } from '@angular/core';
import { StudentassignmentsComponent } from './studentassignments/studentassignments.component';
import { StaffassignmentsComponent } from './staffassignments/staffclasslist.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-assignments',
  standalone: true,
  imports: [
    StudentassignmentsComponent,
    StaffassignmentsComponent,
    CommonModule,
  ],
  templateUrl: './assignments.component.html',
  styleUrls: ['./assignments.component.scss'], // <-- FIXED
})
export class AssignmentsComponent {
  userRole: string = 'student';

  get isStudent(): boolean {
    return this.userRole === 'staff';
  }
}
